/**
 * Tenant profile (ADR-0036 Fase 2) — billing/anagrafica + logo for the CURRENT
 * tenant, edited by its own admin (gated `settings:*`). The superadmin edits any
 * tenant's via the platform client (`lib/platform.ts`). The logo rides as a `data:`
 * URL in the JSON (an `<img src>` can't carry the auth header).
 */
import { api } from "@/lib/api";

export interface TenantAddress {
  street?: string | null;
  city?: string | null;
  zip?: string | null;
  province?: string | null;
  country?: string | null;
}

export interface TenantContact {
  name?: string | null;
  phone?: string | null;
  email?: string | null;
}

/** The editable billing/anagrafica fields (no logo — that's a separate upload). */
export interface TenantProfileIn {
  /** Buyer kind (`private` | `business`) — gates the Italian e-invoicing semantics;
   * "" = non specificato (the backend coerces it to null). Typed loosely so the
   * generic form setter stays happy; the server validates the pattern. */
  entity_type?: string | null;
  legal_name?: string | null;
  vat_number?: string | null;
  tax_code?: string | null;
  pec?: string | null;
  sdi_code?: string | null;
  billing_email?: string | null;
  address?: TenantAddress | null;
  contact?: TenantContact | null;
  external_billing_id?: string | null;
  notes?: string | null;
}

/** The read shape: editable fields + the resolved logo. */
export interface TenantProfile extends TenantProfileIn {
  has_logo: boolean;
  logo_url: string | null;
}

/** The minimal branding the operator header shows (name + logo). */
export interface TenantBrand {
  name: string | null;
  logo_url: string | null;
}

function logoForm(file: File): FormData {
  const fd = new FormData();
  fd.append("file", file);
  return fd;
}

export const tenantProfileApi = {
  /** Header chrome — readable by EVERY operator (no permission gate). */
  getBrand: () => api.get<TenantBrand>("/settings/tenant-brand"),
  get: () => api.get<TenantProfile>("/settings/tenant-profile"),
  update: (body: TenantProfileIn) => api.put<TenantProfile>("/settings/tenant-profile", body),
  uploadLogo: (file: File) =>
    api.upload<TenantProfile>("/settings/tenant-profile/logo", logoForm(file)),
  deleteLogo: () => api.delete<TenantProfile>("/settings/tenant-profile/logo"),
};
